export default __webpack_public_path__ + "static/media/PF.825474cb.svg";